import {Component, Input} from '@angular/core';
import {Icon, Icons} from '../../../model/icon';

@Component({
  selector: 'app-icon',
  imports: [],
  templateUrl: './icon.component.html',
  standalone: true,
  styleUrl: './icon.component.scss'
})
export class IconComponent {
  @Input() icon: Icon = Icons.default;
  @Input() width: number  = 100;
  @Input() height: number = 100;
  @Input() invert: boolean = false;
}
